export default __webpack_public_path__ + "static/media/doc.a40def65.png";